// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.wrap[data-v-3029880e] {\n  padding: 10px;\n  margin-top: 10px;\n  border-radius: 6px;\n  background-color: #f3f3f3;\n}", ""]);
// Exports
module.exports = exports;
